import Theme from '../../../helpers/request/theme';
import * as types from './types';

const ThemeRequest = new Theme();

export const themeGetAll = ({ commit }) => {
  ThemeRequest.get()
    .then(response => commit(types.THEME_SET_LIST, response.data.themes));
};

export const themeGet = ({ dispatch }, slug) => {
  if (!slug) {
    dispatch('themeSetActive', { slug: 'theme1' });
    dispatch('themeUpdateStyles', { slug: 'theme1' });
    return;
  }

  dispatch('themeSetActive', { slug });
};

export const themeSetActive = ({ commit, dispatch, state }, active) => {
  ThemeRequest.get(active.slug)
    .then(response => {
      Object.assign(response.data, active);

      Object.keys(response.data.progressbar).forEach((key) => {
        dispatch('boxUpdateConfig', {
          item: 'progressbar',
          key,
          value: response.data.progressbar[key],
        });
      });

      commit(types.THEME_SET_ACTIVE, response.data);
    });
};

export const themeUpdateStyles = ({ dispatch, rootState }, active) => {
  const boxId = rootState.route.params.boxId;

  ThemeRequest.get(active.slug)
    .then(response => {
      dispatch('boxSetTheme', {
        id: boxId,
        theme_slug: active.slug,
        theme_fonts: response.data.fonts,
      });

      dispatch('quizSetStyle', response.data.styles);
    });
};

export const themeResetState = ({ commit }) => {
  commit(types.THEME_RESET_STATE);
};




/** WEBPACK FOOTER **
 ** ./src/store/modules/theme/actions.js
 **/